/* eslint-disable */
export const util = {
  // View: function () {
  //   return window.com.vizengine.view.View
  // },
  env: function () {
    let Env = {
      // lunaAblumUrl: "//data.pano.visualbusiness.cn/rest/album/view/",
      queryUrl: '//api.show.vizen.cn',
      // lunaUrl: "//luna.visualbusiness.cn",
      WJPlatformUrl: '//show.vizen.cn/weixin/',
      testEnv: false
    }
    // 本地环境
    // if (/-debug|localhost|192.168|0.0.0.0|env=0/.test(window.location.href)) {
    //   // Env.lunaAblumUrl = "//datatest.pano.visualbusiness.cn/rest/album/view/",
    //   // Env.lunaUrl = "//luna-test.visualbusiness.cn";createModelMarker
    //   Env.queryUrl = '//api.show.test.vizen.cn'
    //   Env.WJPlatformUrl = '//show.test.vizen.cn/weixin/'
    //   Env.testEnv = true
    // }
    // 线上环境
    if (/env=1/.test(window.location.href)) {
      // Env.lunaAblumUrl = "//datat.pano.visualbusiness.cn/rest/album/view/",
      // Env.lunaUrl = "//luna.visualbusiness.cn";
      Env.queryUrl = '//api.show.vizen.cn'
      Env.WJPlatformUrl = '//show.vizen.cn/weixin/'
      Env.testEnv = false
    }
    // 测试环境
    if (/env=2/.test(window.location.href)) {
      // Env.lunaAblumUrl = "//datatest.pano.visualbusiness.cn/rest/album/view/",
      // Env.lunaUrl = "//luna-test.visualbusiness.cn";
      Env.queryUrl = '//api.show.test.vizen.cn'
      Env.WJPlatformUrl = '//show.test.vizen.cn/weixin/'
      Env.testEnv = true
    }
    // 预生产环境
    if (/env=3/.test(window.location.href)) {
      Env.queryUrl = '//api.show.pre.vizen.cn'
      // Env.lunaAblumUrl = "//datat.pano.visualbusiness.cn/rest/album/view/",
      // Env.lunaUrl = "//luna.visualbusiness.cn";
      Env.WJPlatformUrl = '//show.vizen.cn/weixin/'
      Env.testEnv = false
    }
    // dev环境
    if (/env=4/.test(window.location.href)) {
      Env.queryUrl = '//api.show.dev.vizen.cn'
      Env.WJPlatformUrl = '//show.test.vizen.cn/weixin/'
      Env.testEnv = true
    }
    return Env
  },
  // 数字转换万单位  例如110300 转为11万
  intToWan: function (num) {
    var numInner = num
    var numInnerString = num.toString()
    if (numInner > 9999) {
      numInnerString = numInnerString.substr(0, numInnerString.length.toString() - 4) + '万'
      numInner = parseInt(numInnerString)
    }
    return numInnerString
  },

  getUrlParam: function (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg); //匹配目标参数
    if (r != null) return decodeURIComponent(r[2]);
    return null; //返回参数值
    // hash
    // let search = '?' + window.location.hash.split('?')[1]
    // var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') //构造一个含有目标参数的正则表达式对象
    // var r = search.substr(1).match(reg) //匹配目标参数
    // if (r != null) {
    //   return decodeURIComponent(r[2])
    // }
    // return null //返回参数值
  },

  imgRatio: function (src, callback) {
    var image = new Image()
    image.src = src
    image.onload = function () {
      return callback(image.naturalWidth / image.naturalHeight)
    }
  },

  preload: function () {
    var imageUrls = []
    var callback = null
    for (var i = 0; i < arguments.length; i++) {
      if (arguments[i] instanceof Function) {
        callback = arguments[i]
      } else if (arguments[i] && typeof(arguments[i]) == 'string') {
        imageUrls.push(arguments[i])
      }
    }
    if (!imageUrls.length) {
      callback()
      return
    }
    var loadedCount = 0
    for (var i = 0; i < imageUrls.length; i++) {
      var imgEle = document.createElement('img')
      imgEle.src = imageUrls[i] ? imageUrls[i].replace('http:', window.location.protocol) : ''
      imgEle.onload = function () {
        loadedCount++
        if (loadedCount == imageUrls.length) {
          callback()
        }
      }
    }
  },

  removeSameEle: function (arr) {
    var n = {},
      r = [],
      len = arr.length,
      val, type
    for (var i = 0; i < len; i++) {
      val = arr[i]
      type = typeof val
      if (!n[val]) {
        n[val] = [type]
        r.push(val)
      } else if (n[val].indexOf(type) < 0) {
        n[val].push(type)
        r.push(val)
      }
    }
    return r
  },

  isAndroid: function () {
    var u = navigator.userAgent
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
    return isAndroid
  },

  isIOS: function () {
    var u = navigator.userAgent
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    return isIOS
  },

  isEmptyObject: function (obj) {
    var name
    for (name in obj) {
      return false
    }
    return true
  },

  isArray: function (o) {
    return Object.prototype.toString.call(o) === '[object Array]'
  },

  setCookie: function (name, value, time) {
    if (time) {
      var exp = new Date()
      exp.setTime(exp.getTime() + time)
      document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString()
    } else {
      document.cookie = name + '=' + escape(value)
    }
  },

  getCookie: function (c_name) {
    let c_start, c_end
    if (document.cookie.length > 0) {
      c_start = document.cookie.indexOf(c_name + '=')
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1
        c_end = document.cookie.indexOf(';', c_start)
        if (c_end == -1) {
          c_end = document.cookie.length
        }
        return unescape(document.cookie.substring(c_start, c_end))
      }
    }
    return ''
  },

  delCookie: function (name) {
    var exp = new Date()
    exp.setTime(exp.getTime() - 1)
    var cval = util.getCookie(name)
    if (cval != null) {
      document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
    }
  },

  tel: function (tel) {
    window.location.href = 'tel:' + tel
  },

  compareByPinyin: function (val1, val2) {
    val1 = val1.toLowerCase()
    val2 = val2.toLowerCase()
    var length = val1.length > val2.length ? val1.length : val2.length
    for (var i = 0; i < length; i++) {
      var differ = val1.charCodeAt(i) - val2.charCodeAt(i)
      if (differ == 0) {
        continue
      } else {
        if (val1.charAt(i) == '_') {
          return -1
        }
        return differ
      }
    }
    if (i == length) {
      return val1.length - val2.length
    }
  },

  distanceFormat: function (dis, lan) {
    // lan ? lan = "zh" : "en";
    var str
    var mStr = lan ? 'm' : '米'
    var kmStr = lan ? 'km' : '公里'
    if (dis <= 1000) {
      str = parseInt(dis) + mStr
    } else if (dis > 1000 && dis < 100000) {
      str = (dis / 1000).toFixed(1) + kmStr
    } else {
      str = parseInt(dis / 1000) + kmStr
    }
    return str
  },

  distanceFormat2: function (dis, lan) {
    // lan ? lan = "zh" : "en";
    var str
    var mStr = lan ? 'm' : '米'
    var kmStr = lan ? 'km' : '公里'
    if (dis <= 1000) {
      str = parseInt(dis) + mStr
    } else if (dis > 1000 && dis < 100000) {
      str = (dis / 1000).toFixed(1) + kmStr
    } else if (dis >= 100000 && dis < 1000000) {
      str = parseInt(dis / 1000) + kmStr
    } else {
      str = '大于999公里'
    }
    return str
  },

  addEventHandler: function (element, type, handler) {
    if (element.addEventListener) {
      element.addEventListener(type, handler, false)
    } else if (element.attachEvent) {
      element.attachEvent('on' + type, handler)
    } else {
      elmenet['on' + type] = handler
    }
  },

  removeEventHandler: function (element, type, handler) {
    if (element.removeEventListener) {
      element.removeEventListener(type, handler, false)
    } else if (element.detachEvent) {
      element.detachEvent('on' + type, handler)
    } else {
      element['on' + type] = null
    }
  },

  // 以下方法均需要依赖第三方库
  // 依赖微信JSSDK
  nav: function (lat, lng, name, address) {
    var ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      lat = parseFloat(lat)
      lng = parseFloat(lng)
      var isAndroid = util.isAndroid()
      var scale = isAndroid ? 14 : 11
      try {
        if (wx) {
          wx.openLocation({
            latitude: lat,
            longitude: lng,
            name: name,
            address: address,
            scale: scale,
            infoUrl: '',
            fail: function (res) {
              alert(JSON.stringify(res))
            }
          })
        } else {
          alert('调用地图失败')
        }
      } catch (e) {
        alert('调用地图失败')
      }
    } else {
      window.location.href = '//apis.map.qq.com/uri/v1/routeplan?type=drive&to=' + name + '&tocoord=' + lat + ',' + lng
    }
  },
  formatTextBr: function (text) {
    if (typeof text === 'string' && /(↵|\s)/.test(text)) {
      text = text.replace(/\n/g, '<br/>').replace(/↵/g, '<br/>').replace(/\s/g, '&nbsp;')
    }
    return text
  },

  // 请求本地数据 依赖jQuery
  // getLocalData: function (url, callback) {
  //   jQuery.getJSON(url, function (data) {
  //     callback(data)
  //   })
  // },

  // 更具经纬度计算两点之间的距离 依赖vizengine库
  getDistance: function (fromLat, fromLon, toLat, toLon) {
    var p1 = new LatLon(fromLat, fromLon)
    var p2 = new LatLon(toLat, toLon)
    var distance = p1.distanceTo(p2)
    return distance
  },

  //计算经纬度对应的heading和pitch
  getHeadingByLatLon: function (fromLat, fromLon, toLat, toLon, angleOffset) {
    // console.log(LatLon)
    var p1 = new LatLon(fromLat, fromLon)
    var p2 = new LatLon(toLat, toLon)
    var angle = p1.bearingTo(p2)
    if (angleOffset) {
      angle -= angleOffset
    }
    return angle
  },

  getPitchByLatLon: function (fromLat, fromLon, toLat, toLon, deltaHeight) {
    if (deltaHeight == null || deltaHeight == 0) {
      deltaHeight = 3
    }
    var p1 = new LatLon(fromLat, fromLon)
    var PI = Math.PI
    var p2 = new LatLon(toLat, toLon)
    var distance = p1.distanceTo(p2)
    return Math.atan(deltaHeight / distance) * 180 / PI
  },

  //解决横屏不支持问题 依赖vizengine库
  forbidScreen: function (view) {
    window.addEventListener('orientationchange', function () {
      if (window.orientation === 180 || window.orientation === 0) {
        console.log('竖屏状态！')
        view.setVisible(false)
      }
      if (window.orientation === 90 || window.orientation === -90) {
        console.log('横屏状态！')
        view.setVisible(true)
      }
    }, false)
  },

  // 依赖vizengine库
  disablePreventTouch: function (view) {
    view.dispatchTouch = function (e) {
      var ret = View.prototype.dispatchTouch.apply(view, arguments)
      if (view.isTouchInside(e)) {
        window.__preventDefault__ = false
      }
      return ret
    }
  },

  // 给View添加calss
  setViewClass: function (view, style) {
    view._nativeView.div.setAttribute('class', style)
  },
  setMaxTxt: function (str, num) {
    if (!str || typeof(str) != 'string') {
      return ''
    }
    return str.length > num ? str.substring(0, num - 1) + '...' : str
  },

  //拆分标题
  getTitleByLine: function (title, type) {
    title = title || ''
    if (title.length <= 7) {
      return [title, '']
    } else if (title.length == 8) {
      return [title.substring(0, 6), title.substring(6)]
    } else {
      if (type == 'album' && window.innerWidth < 330) {
        return [title.substring(0, 7), title.substring(7)]
      }
      return [title.substring(0, 8), title.substring(8)]
    }
  },

  //设置微信title
  setWechartTitle: function (title) {
    document.title = title || '微景平台'
    let iframe = document.createElement('iframe')
    iframe.style.display = 'none';
    iframe.onload = function() {
      setTimeout(function(){
        iframe.remove();
      }, 30)
    }
    document.body.appendChild(iframe);
  },

  //设置正确的协议
  setProtocol: function (url) {
    url = url || ''
    return url.replace(/(^http:\/\/|^https:\/\/|^\/\/)/, window.location.protocol + '//')
  },

  //万象图优化
  WXImage: function (src) {
    src = src || ''
    if (/(cimg)(|[0-9]*)(\.vizen\.cn)/.test(src) && this.frame.width > 0
      && !/(imglarge)/.test(src)) {
      src += '/imglarge'
      if (this.frame.width < 120 && this.frame.width < 120) {
        src += '?imageMogr2/thumbnail/100x/interlace/0'
      } else if (this.frame.width < 220 && this.frame.height < 220) {
        src += '?imageMogr2/thumbnail/200x/interlace/0'
      } else if (this.frame.width < 420 && this.frame.height < 420) {
        src += '?imageMogr2/thumbnail/400x/interlace/0'
      } else if (this.frame.width < 820 && this.frame.height < 820) {
        src += '?imageMogr2/thumbnail/800x/interlace/0'
      } else if (this.frame.width < 1020 && this.frame.height < 1020) {
        src += '?imageMogr2/thumbnail/1000x/interlace/0'
      }
    }
    return src
  },

  //设置统计id
  addStatistics: function (id, cid) {
    if (!id) {
      return
    }
    var mta = document.createElement("script");
    mta.src = "//pingjs.qq.com/h5/stats.js?v2.0.4";
    mta.setAttribute("name", "MTAH5");
    mta.setAttribute("sid", id);
    if (cid) {
      mta.setAttribute("cid", cid);
    }
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(mta, s);
  },

  // 万象图片处理
  getPicUrl: function (picurl,type) {
    var cimgType={
      "thumbnail":"/thumbnail",
      "imgsmall":"/imgsmall",
      "imgmedium":"/imgmedium",
      "imglarge":"/imglarge",
      "imgoriginal":"/imgoriginal",
      "imgsupergraph":"/imgsupergraph"
    };

    if(/(cimg)(|[0-9]*)(\.vizen\.cn)/.test(picurl)){
      picurl = picurl+(cimgType[type]||"");
    }
    return picurl;
  },

  setPano: function (panoInfo, newPanoHeading, callback) {
    let panoId = panoInfo.panoId
    if (this.env().testEnv) {
      panoId = '[TT]' + panoId
    }
    window.pano.setPanoIdAndFilterName(panoId, '',() => {
      window.pano.setHeading(newPanoHeading || panoInfo.heading || 0)
      window.pano.setPitch(0)
      callback && callback()
    })
  },

  //全景设置可否放大缩小、拖动、自动转动
  panoInter: function (boo) {
    // window.pano.touchable = boo
    // window.pano.setMouseWheelEnable(boo)
    // window.pano.setAutoPlayEnable(boo)
  },

  isMobile: function () {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      return true
    } else {
      return false
    }
  },
  throttle(fn, wait = 200) {
    let self = this
    if (!self.timer) {
      self.timer = setTimeout(() => {
        self.timer = null
        fn.apply(this, arguments)
      }, wait)
    }
  },
  // 检查图片前缀
  checkImageUrl: function (url) {
    if (url.indexOf('http') !== -1) {
      return url
    } else {
      return location.protocol + url
    }
  },

  // 初始化全景所需数据
  initData: (data, level) => {
    let json = {}
    if (data.type === 'entity') {
      json['baseInfo'] = null // 详细信息
      json['id'] = data.id
      json['entityId'] = data.id  // 实体id
      json['facilityId'] = data.appreanceId // 全景设施id
      if (data.appreanceInfo.pano) {
        json['panoArray'] = data.appreanceInfo.pano
        json['panoInfo'] = data.appreanceInfo.pano[0]
        json['thumbnail'] = data.thumbnail ? data.thumbnail : data.appreanceInfo.pano[0].thumbnail
      } else {
        json['panoArray'] = []
        json['panoInfo'] = {}
        json['thumbnail'] = data.thumbnail
      }
      json['name'] = data.name
      json['lnglat'] = data.lnglat
      json['type'] = data.type
      json['level'] = level // 层级
      json['isView'] = false
    } else if (data.type === 'facility') {
      json['baseInfo'] = null // 详细信息
      json['entityId'] = data.entityId
      json['id'] = data.id
      json['facilityId'] = data.id
      if (data.pano) {
        json['panoArray'] = data.pano
        json['panoInfo'] = data.pano[0]
        json['thumbnail'] = data.thumbnail ? data.thumbnail : data.pano[0].thumbnail
      } else {
        json['panoArray'] = []
        json['panoInfo'] = {}
        json['thumbnail'] = data.thumbnail
      }
      json['name'] = data.name
      json['lnglat'] = []
      json['type'] = data.type
      json['level'] = level // 层级
      json['isView'] = false
    }
    return json
  },

  isWindowOnblur: () => {
    // let hidden, visibilityChange
    // if (typeof document.hidden !== 'undefined') {
    //   hidden = 'hidden'
    //   visibilityChange = 'visibilitychange'
    // } else if (typeof document.mozHidden !== 'undefined') {
    //   hidden = 'mozHidden'
    //   visibilityChange = 'mozvisibilitychange'
    // } else if (typeof document.msHidden !== 'undefined') {
    //   hidden = 'msHidden'
    //   visibilityChange = 'msvisibilitychange'
    // } else if (typeof document.webkitHidden !== 'undefined') {
    //   hidden = 'webkitHidden'
    //   visibilityChange = 'webkitvisibilitychange'
    // }
    // function handleVisibilityChange () {
    //   if (document[hidden]) {
    //     // isPanoAutoPlay = window.pano.isAutoplayEnabled()
    //     // window.pano.setAutoPlayEnable(false)
    //   } else {
    //     console.log(1)
    //     // window.pano.setAutoPlayEnable(isPanoAutoPlay)
    //   }
    // }
    // if (typeof document.addEventListener === 'undefined' || typeof document[hidden] === 'undefined') {
    //   console.log('不支持')
    // } else {
    //   document.addEventListener(visibilityChange, handleVisibilityChange, false)
    // }

    // 浏览器窗口失去焦点
    window.onblur = () => {
      window.pano.setEnablePlayOnBlur(false)
    }
    // 浏览器窗口获得焦点
    window.onfocus = () => {
      window.pano.setEnablePlayOnBlur(true)
    }
  },

  markerWraper: function (markerInfo) {
    let marker = null
    marker = document.createElement('div') // 可以为任意dom元素
    marker.anchorX = 0.5 // 设置锚点的横坐标(0-1,0表示最左，1表示最右)
    marker.anchorY = 0.5 // 设置锚点的纵坐标(0-1,0表示最上，1表示最下)
    marker.heading = markerInfo.heading // marker在全景中的正北方向的偏转角度
    marker.pitch = markerInfo.pitch // marker在全景中的正北方向的偏转角度
    return marker;
  },

  panoMarker: function (marker) {
    var cell;
    switch (marker.style) {
      case "right":
        cell = this.View().parse({
          layout: "horizontal",
          height: "wrap",
          width: "wrap",
          contentGravity: "center",
          visibility: 'visible',
          children: [{
            id: "name",
            type: "TextView",
            text: marker.name,
            fontSize: "12dp",
            fontColor: "#ffffff",
            height: "wrap",
            width: "wrap",
            visibility: 'visible',
            paddingTop: "8dp"
          },
            {
              id: "icon",
              height: "30dp",
              visibility: 'visible',
              width: "40dp"
            }
          ]
        })
        cell.$("icon")._nativeView.div.setAttribute("class", "movingArrowRight")
        break;
      case "left":
        cell = this.View().parse({
          layout: "horizontal",
          height: "wrap",
          width: "wrap",
          contentGravity: "center",
          visibility: 'visible',
          children: [{
            id: "icon",
            visibility: 'visible',
            height: "40dp",
            width: "40dp"
          },
            {
              id: "name",
              visibility: 'visible',
              type: "TextView",
              text: marker.name,
              fontSize: "12dp",
              fontColor: "#ffffff",
              height: "wrap",
              width: "wrap"
            }
          ]
        })
        cell.$("icon")._nativeView.div.setAttribute("class", "movingArrowLeft")
        break;
      case "top":
        cell = this.View().parse({
          layout: "vertical",
          height: "wrap",
          width: "wrap",
          contentGravity: "center",
          visibility: 'visible',
          children: [{
            id: "icon",
            visibility: 'visible',
            height: "36dp",
            width: "35dp"
          },
            {
              id: "name",
              visibility: 'visible',
              type: "TextView",
              text: marker.name,
              fontSize: "12dp",
              fontColor: "#ffffff",
              height: "wrap",
              width: "wrap"
            }
          ]
        })
        cell.$("icon")._nativeView.div.setAttribute("class", "movingArrowDown")
        break;
      case 'house':
        cell = this.View().parse({
          id: "house",
          width:"wrap",
          height:"wrap",
          anchorX:"0.5",
          anchorY:"0.5",
          layout: 'vertical',
          visibility: 'visible',
          children:[
            {
              id:"iconBlock",
              visibility: 'visible',
              type:"ImageView",
              width:"wrap",
              height:"24dp",
              translateY:"10dp",
              gravity:"centerHorizontal",
              src:"//panoappstage-1251448083.costj.myqcloud.com/ic_marke-house.svg"
            },
            {
              id: "name",
              visibility: 'visible',
              type:"TextView",
              text:marker.name,
              fontColor:"#ffffff",
              width:"wrap",
              fontSize:"14dp",
              translateY:"5dp",
              contentGravity:"centerHorizontal",
              gravity:"bottom"
            }
          ]
        });
        break
      case 'marker-black':
        cell = this.View().parse({
          id: 'marker-black',
          anchorX:"0.5",
          anchorY:"0.5",
          width:"20dp",
          height:"wrap",
          layout:"vertical",
          clipToBounds:true,
          borderCorner:"12dp",
          background:"#90000000",
          visibility: 'visible',
          children:[{
            type:"TextView",
            id: "name",
            visibility: 'visible',
            width:"14dp",
            fontSize:"14dp",
            height:"wrap",
            text:marker.name,
            fontColor:"#ffffff",
            contentGravity:"cente",
            gravity:"centerHorizontal",
            marginTop:"8dp",
            marginBottom:"4dp"
          },{
            id:"iconBlock",
            visibility: 'visible',
            type:"ImageView",
            height:"wrap",
            src:"//panoappstage-1251448083.costj.myqcloud.com/ic_i-normal-cir.png"
          }]
        })
        break
      case 'marker-red':
        cell = this.View().parse({
          anchorX:"0.5",
          anchorY:"1",
          width:"18dp",
          height:"wrap",
          layout:"vertical",
          visibility: 'visible',
          children:[
            {
              visibility: 'visible',
              type:"ImageView",
              height:"wrap",
              src:"//panoappstage-1251448083.costj.myqcloud.com/ic_i-tri.png"
            },
            {
              visibility: 'visible',
              height:"wrap",
              clipToBounds:true,
              borderCorner:"12dp",
              background:"#90ffffff",
              children:[
                {
                  type:"TextView",
                  id: 'name',
                  visibility: 'visible',
                  text:marker.name,
                  fontColor:"#000000",
                  width:"16dp",
                  height:"wrap",
                  fontSize:"14dp",
                  contentGravity:"centerHorizontal",
                  gravity:"centerHorizontal",
                  marginTop:"8dp",
                  marginBottom:"18dp"
                },
                {
                  visibility: 'visible',
                  type:"ImageView",
                  gravity:"center|bottom",
                  height:"wrap",
                  src:"//panoappstage-1251448083.costj.myqcloud.com/ic_i-impo-cir.png"
                }
              ]
            }
          ]
        })
        break
      case "normal":
        cell = this.View().parse({
          layout: "vertical",
          height: "wrap",
          width: "wrap",
          contentGravity: "center",
          visibility: 'visible',
          children: [{
            id: "icon",
            visibility: 'visible',
            height: "36dp",
            width: "23dp"
          },
            {
              id: "name",
              visibility: 'visible',
              type: "TextView",
              // text: marker.heading,
              fontSize: "12dp",
              fontColor: "#ffffff",
              height: "wrap",
              width: "wrap"
            }
          ]
        })
        cell.$("icon")._nativeView.div.setAttribute("class", "movingNormal")
        break;
      default:
        cell = this.View().parse({
          layout: "vertical",
          height: "wrap",
          width: "wrap",
          contentGravity: "center",
          visibility: 'visible',
          children: [{
            id: "icon",
            visibility: 'visible',
            height: "24dp",
            width: "24dp"
          },
            {
              id: "name",
              visibility: 'visible',
              type: "TextView",
              text: marker.name,
              fontSize: "12dp",
              fontColor: "#ffffff",
              height: "wrap",
              width: "wrap"
            }
          ]
        })
        cell.$("icon")._nativeView.div.setAttribute("class", "big-round")
        break;
    }
    return cell
  },

  // 设置三维
  modelSetModelId: function (modelObj, modelInfo, callback) {
    modelInfo.vbrId = modelInfo.vbrId || modelInfo.modelId
    let vbrId = modelInfo.vbrId
    if (vbrId.indexOf('[TT]') !== 0) {
      // vbrId = Env().testEnv ? '[TT]' + vbrId : vbrId
    }
    // modelObj.onModelLoadedCallback = function () {
    //   var image = new Image()
    //   image.setAttribute('crossOrigin', 'anonymous')
    //   image.src = '//panoappstage-1251448083.file.myqcloud.com/mobel/modelDecals.png'
    //   image.onload = function () {
    //     setTimeout(function () {
    //       modelObj.requestDraw()
    //       modelObj.decals(image)
    //     }, 1000)
    //   }
    // }
    modelObj.setModelIdAndJobId(vbrId, modelInfo.path, () => {
      if (modelInfo.pose) {
        let pose
        if (typeof modelInfo.pose === 'string') {
          pose = JSON.parse(modelInfo.pose)
        } else {
          pose = modelInfo.pose
        }
        // 兼容历史数据
        if (pose.pivotVersion) {
          modelObj.reloadPivotInfo(pose)
        } else {
          let data = {
            pivotVersion: 0,
            pose: pose
          }
          modelObj.reloadPivotInfo(data)
        }
      }
      callback && callback()
    })
  },
  // 三维模型添加水印
  modelAddWatermark (model3dView) {
    var image = new Image()
    image.setAttribute('crossOrigin', 'anonymous')
    image.src = '//panoappstage-1251448083.file.myqcloud.com/mobel/modelDecals.png'
    image.onload = function () {
      setTimeout(function () {
        model3dView.requestDraw()
        model3dView.decals(image)
      }, 300)
    }
  },
  startNewPanoAnimation(obj) {
    if (!obj || !obj.panoView) {
      return
    }
    let panoView = obj.panoView,
        toHeading = obj.toHeading,
        toPitch = obj.toPitch,
        callback = obj.callback,
        type = obj.type
    let fromHeading = panoView.getHeading() % 360
    if (fromHeading > 180) {
      fromHeading -= 360
    } else if (fromHeading < -180) {
      fromHeading += 360
    }
    let fromPitch = panoView.getPitch() % 360
    let fromFov = 100
    toHeading = toHeading % 360
    if (toHeading > 180) {
      toHeading -= 360
    } else if (toHeading < -180) {
      toHeading += 360
    }
    // 优化框架旋转
    if (toHeading - fromHeading > 180) {
      toHeading -= 360
    } else if (toHeading - fromHeading < -180) {
      toHeading += 360
    }
    let toFov = 0
    switch (type) {
      case 'enlarge':
        toFov = 60
        break
      case 'shrink':
        toFov = 140
        break
      case 'translation':
        toFov = 80
        break
      case 'normal':
        toFov = 100
        break
      default:
        toFov = 100
        break
    }

    if (obj.toFov || obj.toFov == 0) {
      toFov = obj.toFov
    }
    let animation = new window.TWEEN.Tween({ heading: fromHeading, pitch: fromPitch, fov: fromFov }, panoView.tweenGroup)
      .to({ heading: toHeading, pitch: toPitch, fov: toFov }, 1000)
                // .to({ heading: 360, pitch: 0, fov: 90 }, 3000)
                .onComplete(() => {
                  if (callback) {
                    callback()
                  }
                })
                .onUpdate((objData) => {
                  panoView.setHeading(objData.heading)
                  panoView.setPitch(objData.pitch)
                  panoView.setFov(objData.fov)
                })
    animation.start()
  },
  //pano上的动画
  startPanoAnimation: function (obj) {
    if (!obj || !obj.panoView) {
      return
    }
    var panoView = obj.panoView,
      toHeading = obj.toHeading,
      toPitch = obj.toPitch,
      callback = obj.callback,
      type = obj.type

    var fromHeading = panoView.getHeading() % 360
    if (fromHeading > 180) {
      fromHeading -= 360
    } else if (fromHeading < -180) {
      fromHeading += 360
    }
    var fromPitch = panoView.getPitch() % 360
    var animation = new com.vizengine.animation.PanoAnimation()
    animation.fromHeading = fromHeading
    animation.fromPitch = fromPitch
    animation.fromFov = 100
    var toHeading = toHeading % 360
    if (toHeading > 180) {
      toHeading -= 360
    } else if (toHeading < -180) {
      toHeading += 360
    }
    // 优化框架旋转
    if (toHeading - fromHeading > 180) {
      toHeading -= 360
    } else if (toHeading - fromHeading < -180) {
      toHeading += 360
    }
    animation.toHeading = toHeading
    animation.toPitch = toPitch
    switch (type) {
      case 'enlarge':
        animation.toFov = 60
        break
      case 'shrink':
        animation.toFov = 140
        break
      case 'translation':
        animation.toFov = 80
        break
      case 'normal':
        animation.toFov = 100
        break
      default:
        animation.toFov = 100
        break
    }
    animation.enablePitch = true
    animation.enableHeading = true
    animation.enableFov = true
    animation.duration = 1000
    animation.timeInterplator = new com.vizengine.animation.DecelerateInterpolator(2)
    animation.callback = function () {
      if (callback) {
        callback()
      }
    }
    panoView.startAnimation(animation)
  },

  panoId2index: (pid) => {
    let infos = window.roam.config.panoInfos;
    for (let i=0; i<infos.length; i++) {
      if (infos[i].panoId === pid) {
        return infos[i].index;
      }
    }
    return -1;
  },

  fixIntro (intro) {
    if (intro) {
      let str = intro.replace(/[\n]/g, '<br />')
      let array = str.split('<br />')
      let newStr = ''
      array.forEach((el, i) => {
        newStr = newStr + '<p>' + el + '</p>'
      })
      return newStr
    } else {
      return ''
    }
  },

  clearFiltrationInfo: function () {
    window.roam.hotspots.forEach((h) => {
      h.material.color.setHex(0xffffff)
    })
  },

  loadRoamFile: function (index, callback) {
    this.clearFiltrationInfo()
    let loader = new window.THREE.FileLoader()
    loader.load('./data/modelData.json', (txt) => {
      // window.landMarkerFiltration = JSON.parse(txt)
      console.log('配置文件载入完毕')
      callback && callback()
    })
  },
  clearAllRoamMarker: function (boo) {
    window.roam.hotspots.forEach((h) => {
      h.traverse(c => {
        c.material && c.material.color.setHex(0xffffff)
      })
      // window.roam.setHotspotVisible(h.index, !boo)
      h.visible = !boo
    })
  }



}
